import LegalLayout from "@/components/LegalLayout";
import { useLanguage } from "@/App";

export default function PrivacyPolicy() {
  const { language } = useLanguage();
  const ar = language === "ar";
  return (
    <LegalLayout titleAr="سياسة الخصوصية" titleEn="Privacy Policy">
      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "1. مقدمة" : "1. Introduction"}</h2>
        <p>{ar
          ? "تحترم Arab Sanad (\"نحن\"، \"الشركة\") خصوصيتك. توضّح هذه السياسة كيف نجمع ونستخدم ونحمي ونشارك معلوماتك الشخصية عندما تستخدم منصتنا، سواء كمستخدم عادي أو كمقدّم خدمة أو كباحث عن عمل."
          : "Arab Sanad (\"we\", \"us\") respects your privacy. This Policy explains how we collect, use, protect, and share your personal information when you use our platform — whether as a regular user, a service provider, or a job seeker."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "2. المعلومات التي نجمعها" : "2. Information We Collect"}</h2>
        <ul className="list-disc pr-6 space-y-1">
          <li>{ar ? "الاسم، البريد الإلكتروني، رقم الهاتف، اللغة المفضلة، الصورة الشخصية عند التسجيل." : "Name, email, phone number, preferred language, and avatar at registration."}</li>
          <li>{ar ? "بيانات الموقع (الولاية والمدينة والـ ZIP) لإظهار محتوى مناسب جغرافياً." : "Location data (state, city, ZIP) used to surface geographically relevant content."}</li>
          <li>{ar ? "بيانات الدفع تُعالَج بالكامل عبر Stripe — لا نحتفظ ولا نرى أرقام البطاقات." : "Payment data is processed entirely by Stripe — we do not store or see card numbers."}</li>
          <li>{ar ? "المحتوى الذي تنشره (إعلانات السكن والسيارات وملفات الخدمات والسير الذاتية والصور والفيديوهات والرسائل)." : "Content you publish (housing/vehicle listings, service profiles, resumes, photos, videos, messages)."}</li>
          <li>{ar ? "بيانات تقنية: عنوان IP، نوع المتصفح، معرّف الجهاز، الكوكيز، وسجل تفاعلاتك مع الخدمات." : "Technical data: IP address, browser type, device identifier, cookies, and your interaction history with our services."}</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "3. كيف نستخدم بياناتك" : "3. How We Use Your Data"}</h2>
        <ul className="list-disc pr-6 space-y-1">
          <li>{ar ? "تشغيل الخدمات: عرض السكن والسيارات وملفات الخدمات، حجوزات استقبال المطار، الدردشة والمراسلة، مركز السيرة الذاتية، والمساعد الذكي." : "Operating services: surfacing housing, vehicles, service profiles, airport pickup bookings, chat/messaging, Resume Center, and the AI Assistant."}</li>
          <li>{ar ? "معالجة المدفوعات وإدارة اشتراكات مقدّمي الخدمات والعمولات على المعاملات." : "Processing payments and managing provider memberships and transaction commissions."}</li>
          <li>{ar ? "ترجمة السيرة الذاتية بين العربية والإنجليزية عبر مزوّد ذكاء اصطناعي (نمرّر النصّ فقط دون أي معلومات تعريفية إضافية)." : "Translating resumes between Arabic and English via an AI provider (we send only the resume text without additional identifying data)."}</li>
          <li>{ar ? "مراجعة الصور والفيديوهات المرفوعة (مراجعة بشرية و/أو آلية) قبل ظهورها للعموم." : "Reviewing uploaded photos and videos (human and/or automated review) before they go public."}</li>
          <li>{ar ? "تحسين تجربة المستخدم، اكتشاف الاحتيال، وحماية أمان المنصة." : "Improving UX, detecting fraud, and protecting platform security."}</li>
          <li>{ar ? "الامتثال للالتزامات القانونية والاستجابة لطلبات السلطات المختصة." : "Complying with legal obligations and responding to lawful requests."}</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "4. مشاركة البيانات" : "4. Data Sharing"}</h2>
        <p>{ar
          ? "نحن لا نبيع بياناتك أبداً. نشاركها فقط مع:"
          : "We never sell your data. We share it only with:"}</p>
        <ul className="list-disc pr-6 space-y-1 mt-2">
          <li>{ar ? "مزوّدي البنية التحتية: استضافة، قواعد بيانات، تخزين الصور والفيديوهات." : "Infrastructure providers: hosting, databases, image and video storage."}</li>
          <li>{ar ? "Stripe لمعالجة المدفوعات والعمولات والاسترداد." : "Stripe for payment processing, commissions, and refunds."}</li>
          <li>{ar ? "Google Maps / Places لخدمات الموقع." : "Google Maps / Places for location services."}</li>
          <li>{ar ? "مزوّدي البريد (مثل Resend) لإرسال الإيميلات." : "Email providers (e.g. Resend) for transactional emails."}</li>
          <li>{ar ? "مزوّدي الذكاء الاصطناعي للمساعد الذكي وترجمة السير الذاتية." : "AI providers for the AI Assistant and resume translation."}</li>
          <li>{ar ? "السلطات المختصة عند وجود التزام قانوني واضح (أمر قضائي، طلب استجابة لاحتيال، إلخ)." : "Competent authorities under clear legal obligation (court order, fraud response, etc.)."}</li>
          <li>{ar ? "المستخدمين الآخرين بالحدّ الذي تختاره (مثلاً ملفك العام كمقدم خدمة، إعلان السكن، ملف السيرة الذاتية المنشور)." : "Other users to the extent you choose (e.g. your public provider profile, housing listing, or published resume)."}</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "5. الاحتفاظ بالبيانات" : "5. Data Retention"}</h2>
        <p>{ar
          ? "نحتفظ ببياناتك طوال فترة نشاط حسابك. بعد حذف الحساب نحتفظ بسجلات المعاملات المالية كما يقتضي القانون (عادة 5-7 سنوات)، ويُحذف الباقي خلال 30 يوماً."
          : "We retain your data while your account is active. After deletion we keep financial transaction records as required by law (typically 5–7 years); the rest is deleted within 30 days."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "6. حقوقك" : "6. Your Rights"}</h2>
        <p>{ar
          ? "يحق لك الوصول إلى بياناتك، طلب تصحيحها أو حذفها، تصدير نسخة منها، أو الاعتراض على معالجتها. تواصل معنا على البريد أدناه لممارسة هذه الحقوق."
          : "You may access, correct, delete, or export your data, or object to its processing. Contact us at the email below to exercise these rights."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "7. الأمان" : "7. Security"}</h2>
        <p>{ar
          ? "نستخدم تشفير TLS لجميع الاتصالات، نخزّن كلمات المرور بـ bcrypt، نطبّق المصادقة الثنائية اختيارياً، ولدينا ضوابط وصول صارمة. لا يوجد نظام آمن تماماً 100% لكننا نلتزم بأعلى المعايير المعقولة."
          : "We use TLS for all traffic, store passwords with bcrypt, offer optional two-factor authentication, and apply strict access controls. No system is 100% secure, but we adhere to the highest reasonable standards."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "8. الكوكيز" : "8. Cookies"}</h2>
        <p>{ar
          ? "نستخدم الكوكيز لتذكّر تسجيل الدخول، تخزين تفضيلاتك (اللغة، السمة)، وتحليلات الاستخدام. يمكنك تعطيلها من إعدادات المتصفح لكن قد يؤثر ذلك على الوظائف."
          : "We use cookies to remember your login, store preferences (language, theme), and analyze usage. You may disable them in your browser, but this may affect functionality."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "9. الأطفال" : "9. Children"}</h2>
        <p>{ar ? "الخدمة غير موجَّهة لمن هم دون 16 عاماً ولا نجمع بياناتهم عمداً." : "The service is not directed to users under 16, and we do not knowingly collect their data."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "10. النقل الدولي" : "10. International Transfer"}</h2>
        <p>{ar
          ? "خوادمنا في الولايات المتحدة. باستخدامك المنصة من خارجها فإنك توافق على نقل بياناتك ومعالجتها هناك."
          : "Our servers are located in the United States. By using the platform from outside the US, you consent to transferring and processing your data there."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "11. التواصل" : "11. Contact"}</h2>
        <p>privacy@arabsanad.com</p>
      </section>
    </LegalLayout>
  );
}
